    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
            categories: [],
        }
    }
    
    const state = getDefaultState()

    const getters = {
        categories: state => {
            return state.categories
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        categories: (state, payload) => {
            state.categories = payload
        },
    }

    const actions = {
       
        getCategories: ({commit}) =>{
            commit('updating', true)
            axiosAuth.get('/categories')
            .then(
                res => {
                    commit('updating', false)
                    if(!res.data.message){
                        commit('categories', res.data)
                    }
                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                }
              )
        },

        postCategory ({commit, dispatch}, payload) {
            commit('updating', true)
            axiosAuth.post('/categories', payload)
                .then(
                    res => {
                        commit('trash', res)
                        commit('updating', false)
                        dispatch('getCategories')
                        dispatch('getMenus')
                    }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
                )
        },

        updateCategory: ({commit}, payload) => {
           
            commit('updating', true)
            axiosAuth.patch('/categories/'+ payload._id, payload.data)
            .then(
                res => {
                    commit('trash', res)
                    commit('updating', false)
                    // dispatch('getMenus')                
                }
              )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },

        deleteCategory: ({commit, dispatch}, payload) => {
            commit('updating', true)
            axiosAuth.delete('/categories/'+ payload._id)
            .then(
                () => {
                    dispatch('getCategories')
                    dispatch('getMenus')
                }
              )
            .catch(
                error => {
  
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },
    }

    export default {
        state,
        getters,
        mutations,
        actions
    }